import React from 'react';
import Parameters from './components/Parameters';
import Price from './components/Price';
import Loading from './components/Loading';
import PriceVendor from './components/PriceVendor';
import QuoteTips from './components/price/QuoteTips';

const Fabrication = () => {
  return (
    <>
      <Loading />
      <div className="row">
        <div className="col-lg-4">
          <div className="parameters">
            <Parameters />
          </div>
        </div>
        <div className="col-lg-8">
          <div className="pcb-price-section">
            <Price />
            <PriceVendor />
            <QuoteTips />
          </div>
        </div>
      </div>
    </>
  )
}

export default Fabrication;
